class Authentication {
  public static async login() {
    // user's origin url
    const returnUrl = globalThis.location.href;

    // return url after the first login step
    const endLoginUrl = `/end_login?returnUrl=${returnUrl}`;

    // first login step
    globalThis.location.href = `${AppSettings.API_ENDPOINT_URI}pmsession/login?returnUrl=${endLoginUrl}`;
  }

  public static async logout() {
    const url = `${AppSettings.API_ENDPOINT_URI}pmsession/logout?returnUrl=/`;
    globalThis.location.href = `${url}`;
  }

  public static async deletedProfileLogout() {
    const url = `${AppSettings.API_ENDPOINT_URI}pmsession/logout?returnUrl=/profile_removed`;
    globalThis.location.href = `${url}`;
  }

}

export default Authentication;
